export default __webpack_public_path__ + "static/media/18.68a09475.png";